import { render } from "./TemplateEditor.vue?vue&type=template&id=5de22c9b&scoped=true"
import script from "./TemplateEditor.vue?vue&type=script&lang=js"
export * from "./TemplateEditor.vue?vue&type=script&lang=js"

import "./TemplateEditor.vue?vue&type=style&index=0&id=5de22c9b&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5de22c9b"]])

export default __exports__